export default __webpack_public_path__ + "static/media/cryptofont-webfont.f361849e.svg";